import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-447c3903"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "architecture" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "box_content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "星汉未来全场景通用Serverless平台实现了部署、发布、性能、稳定性治理的全自动化，", -1 /* HOISTED */))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "基于此Serverless平台提供的多活解决方案，能将整套业务应用一键复制到多套环境中。", -1 /* HOISTED */))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "只需要管理其中一套环境，相关数据及设置会自动同步至其他环境。", -1 /* HOISTED */))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "提供应用治理、中间件统一治理、数据备份等能力，大大降低业务多活部署的难度和运维复杂度。", -1 /* HOISTED */))
const _hoisted_9 = { class: "box_image" }
const _hoisted_10 = ["src"]
const _hoisted_11 = ["src"]
const _hoisted_12 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_a_typography_paragraph = _resolveComponent("a-typography-paragraph")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_typography_title, { level: 1 }, {
        default: _withCtx(() => [
          _createTextVNode(" 方案架构 ")
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_a_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, {
            xs: 24,
            lg: 12
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_a_typography_title, { level: 5 }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 基于通用Serverless平台"),
                    _hoisted_4,
                    _createTextVNode("的多活部署方案 ")
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_a_typography_paragraph, null, {
                  default: _withCtx(() => [
                    _hoisted_5,
                    _hoisted_6,
                    _hoisted_7,
                    _hoisted_8
                  ]),
                  _: 1 /* STABLE */
                })
              ])
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_a_col, {
            xs: 24,
            lg: 12
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("img", {
                  alt: "",
                  src: $data.file.ImageBottom
                }, null, 8 /* PROPS */, _hoisted_10),
                _createElementVNode("img", {
                  alt: "",
                  src: $data.file.Image
                }, null, 8 /* PROPS */, _hoisted_11),
                _createElementVNode("img", {
                  alt: "",
                  src: $data.file.ImageBorder
                }, null, 8 /* PROPS */, _hoisted_12)
              ])
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      })
    ])
  ]))
}